export default {
  data: () => ({
  }),
  computed: {
    erSatzLevel() {
      return this.$store.getters.erSatzLevel;
    },
    course() {
      return this.$store.getters.course;
    },
    idModes0() {
      return this.$store.getters.idModes0;
    },
    idModes0Names() {
      return this.$store.getters.idModes0Names;
    },
    idMode0() {
      return this.$store.getters.idMode0;
    },
    progressModes() {
      return this.$store.getters.progressModes;
    },
    modes() {
      return this.$store.getters.modes;
    },
    mode() {
      return this.$store.getters.mode;
    }
  },
  methods: {
    async updateProgressModes() {
      this.loading = true;
      let progressModes = [];
      let progressModeRegime = {};
      for (let mode of this.modes) {
        for (let idMode0 of this.idModes0) {
          const progress = await this.$store.dispatch(
            "getCourseModeRegimeProgress",
            {
              idUser: this.user.id,
              idMode: mode.id,
              idMode0: idMode0
            }
          );
          progressModeRegime = {
            idMode: mode.id,
            idMode0: idMode0,
            erSatz: progress[2]
          };
          progressModes.push(progressModeRegime);
        }
      }
      this.$store.commit("setProgressModes", progressModes);
      this.loading = false;
    },
    getProgressModeRegimeByIdModeAndIdMode0(idMode, idMode0) {
      const progressMode = this.progressModes.find(progressModeRegime => {
        return (
          progressModeRegime.idMode === idMode &&
          progressModeRegime.idMode0 === idMode0
        );
      });
      return progressMode ? progressMode : "";
    },
    getErSatzPercentByIdModeAndIdMode0(idMode, idMode0) {
      return (
        Number(
          this.getProgressModeRegimeByIdModeAndIdMode0(idMode, idMode0).erSatz
        ) * 100
      ).toFixed(1);
    },
    async setModeRegime(idMode, idMode0) {
      if (this.mode.id !== idMode) {
        this.$store.commit("clearCourseModeVideoState");
        this.$store.commit("clearModeState");
        const mode = this.modes.find(element => {
          return element.id == idMode;
        });
        this.$store.commit("setMode", {
          mode: mode
        });
        await this.$store.dispatch("getCourseModeSatzes", {
          idUser: this.user.id,
          id: idMode
        });

        this.$store.commit("clearRegimeState");
        this.$store.commit("setRegime", {
          idMode0: idMode0
        });

        this.$router.push("/course/mode");
        return;
      }

      if (this.idMode0 !== idMode0) {
        this.$store.commit("clearRegimeState");
        this.$store.commit("setRegime", {
          idMode0: idMode0
        });

        this.$router.push("/course/mode");
        return;
      }
      this.$router.push("/course/mode");
    }
  },
};
